<template>
  <div class="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-3 bg-white p-2 rounded shadow-sm">
    <button class="btn btn-warning btn-sm px-2 py-1" style="white-space: nowrap;" @click="$emit('add-device')">
    <i class="bi bi-plus-lg me-1"></i> Add Device
  </button>

    <div class="d-flex align-items-center gap-2 flex-wrap flex-grow-1 justify-content-end">
      <select
        v-model="sortKey"
        class="form-select form-select-sm"
        style="max-width: 110px;"
        @change="handleSort"
      >
        <option value="id">ID</option>
        <option value="name">Place</option>
        <option value="device_type">Type</option>
        <option value="price">Price</option>
        <option value="template_id">Template ID</option>
        <option value="paper">Paper Level</option>
        <option value="active">Active Status</option>
        <option value="last_seen">Last Seen</option>
        <option value="regdate">Registered Date</option>
      </select>

      <button
        class="btn btn-sm btn-outline-secondary btn-light d-flex align-items-center"
        @click="toggleSortOrder"
        :title="sortOrder === 'asc' ? 'Ascending' : 'Descending'"
      >
        <i
          :class="sortOrder === 'asc' ? 'bi bi-sort-up' : 'bi bi-sort-down'"
        ></i>
      </button>
    </div>
  </div>
</template>
  
  
<script>
export default {
  props: {
    devices: {
      type: Array,
      required: true,
    },
    defaultSort: {
      type: String,
      default: "id",
    },
  },
  data() {
    return {
      sortKey: this.defaultSort,
      sortOrder: "desc",
    };
  },
  methods: {
    handleSort() {
      const sorted = [...this.devices].sort((a, b) => {
        let result = 0;

        if (this.sortKey === "id") result = a.id - b.id;
        else if (this.sortKey === "name") result = a.name.localeCompare(b.name);
        else if (this.sortKey === "device_type")
          result = a.device_type.localeCompare(b.device_type);
        else if (this.sortKey === "template_id")
          result = a.template_id - b.template_id;
        else if (this.sortKey === "price")
          result = a.price.default_unit - b.price.default_unit;
        else if (this.sortKey === "paper") result = b.paper - a.paper;
        else if (this.sortKey === "active") result = b.active - a.active;
        else if (this.sortKey === "last_seen")
          result = new Date(b.last_seen) - new Date(a.last_seen);
        else if (this.sortKey === "regdate")
          result = new Date(b.regdate) - new Date(a.regdate);

        if (
          this.sortKey === "paper"
          || this.sortKey === "last_seen"
          || this.sortKey === "regdate"
        ) {
          return this.sortOrder === "asc" ? -result : result;
        }

        return this.sortOrder === "asc" ? result : -result;
      });

      this.$emit("sorted", sorted);
    },
    toggleSortOrder() {
      this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      this.handleSort();
    },
  },
  mounted() {
    this.handleSort();
  },
  watch: {
    devices: {
      handler(newDevices) {
        if (newDevices && newDevices.length) {
          this.handleSort();
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
